import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';
import { IMAGE_TYPE } from '@ux/components/image/constants/image-type.constants';
import { HomeItemDetail } from '@home-item-detail/entities/home-item-detail';
import { EventDataLayer } from '@avo/interface/trigger-props';

@Component({
  selector: 'app-home-item-header',
  templateUrl: './home-item-header.component.html',
  styleUrls: ['./home-item-header.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HomeItemHeaderComponent {

  @Input() isMobile: boolean;
  @Input() homeItemDetail: HomeItemDetail;
  @Input() hasWidgets: boolean;

  @Output() trackEvent: EventEmitter<EventDataLayer> = new EventEmitter<EventDataLayer>();

  constructor() { }


  public typeImageFlight: string = IMAGE_TYPE.FLIGHT;

  get showLogo(): boolean {
    return !isNullOrUndefined(this.homeItemDetail.logo_url);
  }

 
}
